import React, { useState, useMemo } from 'react';
import DateField from '../Shared/DateField';
import ProceduraFileSection from '../Shared/ProceduraFileSection';
import { FilterPill } from '../Shared/FilterPill';
import './Tracker.css';

/* ── Tipurile de notificari, cu termenul implicit ── */
const TIPURI_NOTIFICARE = {
  osim: [
    ['refuz_provizoriu',          'Aviz de refuz provizoriu — motive absolute',                  'osim_raspuns_zile',      'zile'],
    ['refuz_provizoriu_relativ',  'Aviz de refuz provizoriu — motive relative',                  'osim_raspuns_zile',      'zile'],
    ['iregularitati_lista',       'Iregularitati privind lista de produse si servicii',           'osim_iregularitati_zile','zile'],
    ['iregularitati_formale',     'Iregularitati formale ale cererii',                           'osim_iregularitati_zile','zile'],
    ['notificare_taxa',           'Notificare privind neplata sau plata partiala a taxelor',     'osim_iregularitati_zile','zile'],
    ['observatii_terti',          'Observatii formulate de terti',                               'osim_raspuns_zile',      'zile'],
  ],
  euipo: [
    ['motive_respingere',         'Notificare cu privire la motivele de respingere a cererii',   'euipo_raspuns_luni',      'luni'],
    ['iregularitati_clasificare', 'Notificare de iregularitati privind lista de produse',        'euipo_iregularitati_luni','luni'],
    ['iregularitati_formale',     'Notificare de iregularitati formale',                         'euipo_iregularitati_luni','luni'],
    ['prioritate',                'Notificare privind revendicarea prioritatii sau senioritatii','euipo_iregularitati_luni','luni'],
    ['observatii_terti',          'Observatii formulate de terti',                               'euipo_raspuns_luni',      'luni'],
  ],
};

const MOTIVE = {
  osim: [
    ['distinctiv',   'Lipsa caracterului distinctiv — art. 5 alin. (1) lit. b)'],
    ['descriptiv',   'Caracter descriptiv — art. 5 alin. (1) lit. c)'],
    ['uzual',        'Semn devenit uzual in limbajul curent — art. 5 alin. (1) lit. d)'],
    ['inselator',    'Semn de natura sa induca publicul in eroare'],
    ['ordine_publica','Contrar ordinii publice sau bunelor moravuri'],
    ['embleme',      'Embleme de stat, steme, semne oficiale'],
    ['ig',           'Conflict cu o indicatie geografica sau denumire de origine'],
    ['relative',     'Motive relative — drepturi anterioare'],
  ],
  euipo: [
    ['7_1_b', 'Lipsa caracterului distinctiv — art. 7 alin. (1) lit. (b)'],
    ['7_1_c', 'Caracter descriptiv — art. 7 alin. (1) lit. (c)'],
    ['7_1_d', 'Semn devenit uzual — art. 7 alin. (1) lit. (d)'],
    ['7_1_e', 'Forma impusa de natura produsului sau functionala — lit. (e)'],
    ['7_1_f', 'Contrar ordinii publice sau bunelor moravuri — lit. (f)'],
    ['7_1_g', 'Semn inselator — art. 7 alin. (1) lit. (g)'],
    ['7_1_h_i','Embleme, semne oficiale — lit. (h) si (i)'],
    ['7_1_j_k','Conflict cu o indicatie geografica sau o mentiune traditionala'],
    ['clasificare','Termeni neclari sau imprecisi in lista de produse si servicii'],
  ],
};

const SOLUTII = [
  ['',                '— in lucru —'],
  ['retras',          'Obiectia a fost retrasa — cererea continua'],
  ['retras_partial',  'Obiectia retrasa partial — lista limitata'],
  ['mentinut',        'Refuz mentinut — cerere respinsa'],
  ['mentinut_partial','Refuz mentinut partial'],
  ['lista_acceptata', 'Lista reformulata a fost acceptata'],
  ['fara_raspuns',    'Fara raspuns — cerere considerata retrasa'],
  ['divizata',        'Cererea a fost divizata'],
];

const CONFIG_DEFAULT = {
  osim_raspuns_zile:       30,
  osim_prelungire_zile:    30,
  osim_iregularitati_zile: 30,
  euipo_raspuns_luni:       2,
  euipo_prelungire_luni:    2,
  euipo_iregularitati_luni: 2,
  contestatie_osim_zile:   30,
  recurs_euipo_luni:        2,
};

/* ── Helpers ── */
const todayMid = () => { const d = new Date(); d.setHours(0,0,0,0); return d; };
const parseISO = (s) => (s ? new Date(s + 'T00:00:00') : null);
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
const addMonths = (d, m) => { const x = new Date(d); x.setMonth(x.getMonth() + m); return x; };
const fmtRO = (d) => d ? d.toLocaleDateString('ro-RO', { day:'2-digit', month:'2-digit', year:'numeric' }) : '—';
const daysLeft = (d) => d ? Math.ceil((d - todayMid()) / 86400000) : null;

const defNotificare = (r) => {
  const lista = TIPURI_NOTIFICARE[r.oficiu] || TIPURI_NOTIFICARE.osim;
  return lista.find(([k]) => k === r.tipNotificare) || lista[0];
};

export function emptyRecord() {
  return {
    oficiu: 'osim',                  // osim | euipo
    tipNotificare: 'refuz_provizoriu',
    numarCerere: '',
    denumire: '',
    clase: '',
    client: '',
    dataComunicareNotif: '',
    motive: [],
    termeniVizati: '',
    prelungireCeruta: false,
    dataPrelungire: '',
    raspunsDepus: false,
    dataRaspuns: '',
    listaLimitata: false,
    solutieNotificare: '',
    dataSolutie: '',
    contestat: false,
    observatii: '',
  };
}

function deriveStatus(r, CFG) {
  const def = defNotificare(r);
  const com = parseISO(r.dataComunicareNotif);
  const unitate = def[3];
  const durata = CFG[def[2]] || 0;

  let termenRaspuns = com
    ? (unitate === 'luni' ? addMonths(com, durata) : addDays(com, durata))
    : null;
  const termenBaza = termenRaspuns;

  if (termenRaspuns && r.prelungireCeruta) {
    termenRaspuns = r.oficiu === 'euipo'
      ? addMonths(termenRaspuns, CFG.euipo_prelungire_luni)
      : addDays(termenRaspuns, CFG.osim_prelungire_zile);
  }

  const sol = parseISO(r.dataSolutie);
  const refuzMentinut = ['mentinut', 'mentinut_partial'].includes(r.solutieNotificare);
  const termenAtac = sol && refuzMentinut && !r.contestat
    ? (r.oficiu === 'euipo'
        ? addMonths(sol, CFG.recurs_euipo_luni)
        : addDays(sol, CFG.contestatie_osim_zile))
    : null;

  const steps = [
    { key:'notificare',  label:'Notificare primita',       done: !!com,              date: com },
    { key:'raspuns',     label:'Raspuns depus',            done: r.raspunsDepus,     date: termenRaspuns },
    { key:'solutie',     label:'Solutie comunicata',       done: !!r.solutieNotificare, date: sol },
    { key:'contestatie', label:'Contestat / recurs',       done: !!r.solutieNotificare && (!refuzMentinut || r.contestat || (termenAtac && todayMid() > termenAtac)), date: termenAtac },
  ];

  let alert;
  if (!com) {
    alert = { label:'De completat data comunicarii notificarii', sev:'neutral' };
  } else if (!r.raspunsDepus && termenRaspuns) {
    alert = {
      label: r.oficiu === 'euipo' ? 'Termen pentru observatii la notificare' : 'Termen de raspuns la aviz',
      date: termenRaspuns, sev:'act',
    };
  } else if (!r.solutieNotificare) {
    alert = { label:'In asteptarea raspunsului oficiului', sev:'info' };
  } else if (termenAtac) {
    alert = {
      label: r.oficiu === 'euipo' ? 'Termen pentru recurs la camera de recurs' : 'Termen de contestatie impotriva deciziei',
      date: termenAtac, sev:'act',
    };
  } else if (r.contestat) {
    alert = { label:'Contestatie / recurs depus — in examinare', sev:'info' };
  } else {
    alert = { label:'Dosar inchis', sev:'done' };
  }

  if (alert.date) {
    const dl = daysLeft(alert.date);
    alert.daysLeft = dl;
    if (dl < 0 && alert.sev === 'act') alert.sev = 'overdue';
  }

  return { def, steps, alert, termenBaza, termenRaspuns, termenAtac, refuzMentinut };
}

/* ════════════════════════ Component ════════════════════════ */
export default function NotificareAvizTracker({ data, onChange, procId, showToast, pendingFiles, onPendingFilesChange }) {
  const [r, setR] = useState(data);
  const [cfg, setCfg] = useState(CONFIG_DEFAULT);
  const [showSetari, setShowSetari] = useState(false);

  const set = (patch) => {
    const next = { ...r, ...patch };
    setR(next);
    onChange(next);
  };

  const status = useMemo(() => deriveStatus(r, cfg), [r, cfg]);
  const motiveLista = MOTIVE[r.oficiu] || MOTIVE.osim;
  const tipuriNotificare = TIPURI_NOTIFICARE[r.oficiu] || TIPURI_NOTIFICARE.osim;

  const toggleMotiv = (k) => {
    const m = r.motive.includes(k) ? r.motive.filter(x => x !== k) : [...r.motive, k];
    set({ motive: m });
  };

  const schimbaOficiu = (v) => {
    const primulTip = TIPURI_NOTIFICARE[v][0][0];
    set({ oficiu: v, tipNotificare: primulTip, motive: [] });
  };

  return (
    <div className="tracker">
      <AlertBanner status={status} />
      <Timeline steps={status.steps} />

      {/* Identificare */}
      <TrackerCard title="Notificarea">
        <div className="field">
          <label>Oficiul emitent</label>
          <SegControl value={r.oficiu} onChange={schimbaOficiu}
            options={[['osim','OSIM (national)'],['euipo','EUIPO (UE)']]} />
        </div>
        <div className="field">
          <label>Tipul notificarii</label>
          <FilterPill value={r.tipNotificare} onChange={e => set({ tipNotificare: e.target.value })}>
            {tipuriNotificare.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </FilterPill>
        </div>
        <div className="f-row">
          <div className="field">
            <label>Nr. cerere / depozit</label>
            <input type="text" value={r.numarCerere} onChange={e => set({ numarCerere: e.target.value })} className="mono" />
          </div>
          <div className="field">
            <label>Denumirea marcii / semnului</label>
            <input type="text" value={r.denumire} onChange={e => set({ denumire: e.target.value })} />
          </div>
        </div>
        <div className="f-row">
          <div className="field">
            <label>Clase vizate</label>
            <input type="text" value={r.clase} onChange={e => set({ clase: e.target.value })} className="mono" />
          </div>
          <div className="field">
            <label>Client</label>
            <input type="text" value={r.client} onChange={e => set({ client: e.target.value })} />
          </div>
        </div>
        <div className="field">
          <label>Data comunicarii notificarii</label>
          <DateField value={r.dataComunicareNotif} onChange={v => set({ dataComunicareNotif: v })} />
          {status.termenBaza && !r.prelungireCeruta && (
            <span className="f-hint">Termen de raspuns: {fmtRO(status.termenBaza)} ({daysLeft(status.termenBaza)} zile)</span>
          )}
        </div>

        <div className="tr-divider">Motivele notificarii</div>
        <div style={{ display:'flex', flexDirection:'column', gap: 4 }}>
          {motiveLista.map(([k, l]) => (
            <label key={k} className="check-label">
              <input type="checkbox" checked={r.motive.includes(k)} onChange={() => toggleMotiv(k)} />
              {l}
            </label>
          ))}
        </div>
        {r.tipNotificare !== 'observatii_terti' && (
          <div className="field mt8">
            <label>Termenii vizati de notificare</label>
            <textarea className="tr-textarea" rows={2} value={r.termeniVizati} onChange={e => set({ termeniVizati: e.target.value })}
              placeholder="Termenii sau clasele care fac obiectul notificarii…" />
          </div>
        )}
      </TrackerCard>

      {/* Desfasurare */}
      <TrackerCard title="Desfasurarea procedurii">
        {status.termenRaspuns && !r.raspunsDepus && (
          <DeadlineChip label={`Termen ${r.prelungireCeruta ? 'prelungit ' : ''}de raspuns`} date={status.termenRaspuns} act />
        )}
        <label className="check-label mt8">
          <input type="checkbox" checked={r.prelungireCeruta} onChange={e => set({ prelungireCeruta: e.target.checked })} />
          {r.oficiu === 'euipo' ? `Prelungire ceruta (+${cfg.euipo_prelungire_luni} luni)` : `Prelungire ceruta (+${cfg.osim_prelungire_zile} zile)`}
        </label>
        {r.prelungireCeruta && (
          <div className="field" style={{ marginLeft: 22 }}>
            <label>Data cererii de prelungire</label>
            <DateField value={r.dataPrelungire} onChange={v => set({ dataPrelungire: v })} />
            {status.termenRaspuns && <span className="f-hint">Nou termen: {fmtRO(status.termenRaspuns)} ({daysLeft(status.termenRaspuns)} zile)</span>}
          </div>
        )}

        <label className="check-label mt8">
          <input type="checkbox" checked={r.raspunsDepus} onChange={e => set({ raspunsDepus: e.target.checked })} />
          Raspunsul / observatiile au fost depuse
        </label>
        {r.raspunsDepus && (
          <div className="field" style={{ marginLeft: 22 }}>
            <label>Data depunerii raspunsului</label>
            <DateField value={r.dataRaspuns} onChange={v => set({ dataRaspuns: v })} />
          </div>
        )}

        <label className="check-label mt8">
          <input type="checkbox" checked={r.listaLimitata} onChange={e => set({ listaLimitata: e.target.checked })} />
          Lista de produse si servicii a fost limitata
        </label>

        <div className="tr-divider mt8">Decizia oficiului</div>
        <div className="f-row">
          <div className="field">
            <label>Solutia</label>
            <FilterPill value={r.solutieNotificare} onChange={e => set({ solutieNotificare: e.target.value })}>
              {SOLUTII.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </FilterPill>
          </div>
          <div className="field">
            <label>Data solutiei</label>
            <DateField value={r.dataSolutie} onChange={v => set({ dataSolutie: v })} />
          </div>
        </div>
        {status.refuzMentinut && status.termenAtac && (
          <DeadlineChip label={r.oficiu === 'euipo' ? `Termen recurs (${cfg.recurs_euipo_luni} luni)` : `Termen contestatie (${cfg.contestatie_osim_zile} zile)`}
            date={status.termenAtac} act={!r.contestat} />
        )}
        <label className={`check-label mt4${!status.refuzMentinut ? ' disabled' : ''}`}>
          <input type="checkbox" disabled={!status.refuzMentinut} checked={r.contestat} onChange={e => set({ contestat: e.target.checked })} />
          {r.oficiu === 'euipo' ? 'S-a formulat recurs la camera de recurs' : 'Decizia a fost contestata la OSIM'}
        </label>
      </TrackerCard>

      {/* Configuratie */}
      <TrackerCard title="Configuratie termene">
        <button type="button" className="btn-link" onClick={() => setShowSetari(s => !s)}>
          {showSetari ? '▾' : '▸'} Termene procedurale (editabile)
        </button>
        {showSetari && (
          <div className="tarife-editor mt8">
            <div className="tr-divider">OSIM (zile)</div>
            {[['osim_raspuns_zile','Termen raspuns'],['osim_prelungire_zile','Prelungire'],['osim_iregularitati_zile','Iregularitati'],['contestatie_osim_zile','Contestatie']
            ].map(([k, l]) => (
              <label key={k} className="tarife-field">{l}
                <input type="number" value={cfg[k]} onChange={e => setCfg({ ...cfg, [k]: Number(e.target.value)||0 })} />
              </label>
            ))}
            <div className="tr-divider">EUIPO (luni)</div>
            {[['euipo_raspuns_luni','Termen raspuns'],['euipo_prelungire_luni','Prelungire'],['euipo_iregularitati_luni','Iregularitati'],['recurs_euipo_luni','Recurs camera']
            ].map(([k, l]) => (
              <label key={k} className="tarife-field">{l}
                <input type="number" value={cfg[k]} onChange={e => setCfg({ ...cfg, [k]: Number(e.target.value)||0 })} />
              </label>
            ))}
          </div>
        )}
      </TrackerCard>

      <TrackerCard title="Observatii interne">
        <textarea className="tr-textarea" value={r.observatii} onChange={e => set({ observatii: e.target.value })}
          rows={3} placeholder="Argumentele raspunsului, strategia, legatura cu alte proceduri…" />
      </TrackerCard>

      <TrackerCard title="Fisiere procedura">
        <ProceduraFileSection
          procId={procId}
          showToast={showToast}
          pendingFiles={pendingFiles}
          onPendingFilesChange={onPendingFilesChange}
        />
      </TrackerCard>
    </div>
  );
}

/* ── Sub-components ── */
function AlertBanner({ status }) {
  const { alert } = status;
  return (
    <div className={`tr-alert sev-${alert.sev}`}>
      <strong>{alert.label}</strong>
      {alert.date && (
        <span className="tr-alert-date">
          Termen: {fmtRO(alert.date)}
          {typeof alert.daysLeft === 'number' && (
            alert.daysLeft < 0 ? ` · depasit cu ${Math.abs(alert.daysLeft)} zile` : ` · ${alert.daysLeft} zile ramase`
          )}
        </span>
      )}
    </div>
  );
}

function Timeline({ steps }) {
  const activeIdx = steps.findIndex(s => !s.done);
  return (
    <div className="tr-timeline">
      {steps.map((s, i) => {
        const isActive = i === activeIdx;
        const done = s.done;
        return (
          <React.Fragment key={s.key}>
            {i > 0 && <span className={`tl-line${done || steps[i-1].done ? ' tl-line-done' : ''}`} />}
            <div className="tl-step">
              <span className={`tl-dot${done ? ' done' : isActive ? ' active' : ''}`}>{done ? '✓' : i+1}</span>
              <span className={`tl-label${isActive ? ' active' : done ? ' done' : ''}`}>{s.label}</span>
              {s.date && <span className="tl-date">{fmtRO(s.date)}</span>}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

function TrackerCard({ title, badge, children }) {
  return (
    <div className="tr-card">
      <div className="tr-card-head">
        <span className="tr-card-title">{title}</span>
        {badge && <span className="tr-badge">{badge}</span>}
      </div>
      <div className="tr-card-body">{children}</div>
    </div>
  );
}

function SegControl({ value, onChange, options }) {
  return (
    <div className="seg-ctrl">
      {options.map(([v, label]) => (
        <button key={v} type="button" className={`seg-btn${value === v ? ' seg-active' : ''}`}
          onClick={() => onChange(v)}>{label}</button>
      ))}
    </div>
  );
}

function DeadlineChip({ label, date, act }) {
  if (!date) return null;
  const dl = daysLeft(date);
  const overdue = dl < 0;
  const soon = dl >= 0 && dl <= 14;
  const cls = overdue ? 'chip-overdue' : (act && soon) ? 'chip-act' : 'chip-neutral';
  return (
    <div className={`deadline-chip ${cls}`}>
      <span>{label}</span>
      <span>{fmtRO(date)} · {overdue ? `${Math.abs(dl)}z depasit` : `${dl}z`}</span>
    </div>
  );
}
